export default "__VITE_ASSET__DjutkgJt__"